import { VolatilityProfile } from '../../types/entities';

export interface VolatilityProfileState {
  loading: boolean;
  loaded: boolean;
  error?: string | undefined;
  profiles: VolatilityProfile[];
}

export const initialState: VolatilityProfileState = {
  loading: false,
  loaded: false,
  profiles: []
};
